<template>
    <iframe class="frame frame--fullscreen" src="/forbidden/index.html"></iframe>
</template>

<script>

export default {
    name: 'AForbidden',
}
</script>
<style type="scss">
.frame{
  border: 0;
}

.frame--fullscreen{
  position: fixed;
  z-index: 999999999999999;
  width: 100vw;
  height: 100vh;
}
</style>
